<template>
  <div>
    <el-dialog title="跟进进度" :close-on-click-modal="false" :visible.sync="visible" width="80%">
     <div style="margin-bottom: 10px;text-align: right;">
      <el-button type="primary" size="mini"  @click="add()">
              <i class="el-icon-plus"></i>添加
            </el-button>
     </div>
     <el-table
     size="mini"
      :data="tableData"
      style="width: 100%;"
      border
      stripe
      >
      <el-table-column type="index" align="center" label="序号" width="55" />
      <el-table-column prop="handler" align="center" label="处理人"  />
      <el-table-column prop="processTime" align="center" label="处理时间"  />
      <el-table-column prop="content" align="center" label="处理内容" />
      <el-table-column align="center" label="操作" width="80">
        <template slot-scope="scope">
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row)">
              <el-button slot="reference" size="mini" type="danger">删除</el-button>
            </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    </el-dialog>
    <el-dialog title="添加进度" :close-on-click-modal="false" :visible.sync="visibleAdd" width="40%" >
      <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
        <el-form-item label="处理人">
          <el-input v-model="formData.handler" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="处理时间">
          <el-date-picker style="width: 100%"
            v-model="formData.processTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="处理内容">
          <el-input v-model="formData.content" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAdd = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveActivitiesType } from '@/api/oa/activitiesTypeManageApi'
import { updateComplaintProgress,saveComplaintProgress,listComplaintProgress, deleteComplaintProgress } from '@/api/oa/complaintApi'
import { getUserId, getUserName } from '@/api/user/userApi'

export default {
  name: 'AddActivitiesType',
  data() {
    return {
      visible: false,
      visibleAdd: false,
      formData: {
        typeName: '',
        typeDesc: '',
        seq: '',
        defaultShow: '',
        communityId: '',
        complaintId: ''
      },
      rules: {

      },
      tableData: [],
      data:{}
    }
  },
  methods: {
    async getList() {
      const params = {
        complaintId:this.data.complaintId
      }
      const response = await listComplaintProgress(params)
      this.tableData = response.data
    },
    add() {
       this.formData = {
        complaintId: this.data.complaintId,
        handler: getUserName(),
        processTime: '',
        content: ''
      }
      this.visibleAdd = true
     
    },
    open(data) {
      this.data = data
      this.complaintId = data.complaintId
      this.visible = true
      this.getList()
      // this.formData.communityId = getCommunityId()
      // this.$nextTick(() => {
      //   this.$refs.form && this.$refs.form.resetFields()
      // })
    },
    handleClose() {
      // this.$refs.form.resetFields()
    },
    handleDelete(row) {
      deleteComplaintProgress({
        id: row.id
      }).then(res => {
        if(res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    async handleSubmit() {
      if(!this.formData.handler) {
        this.$message.error('请输入处理人')
        return
      }
      if(!this.formData.processTime) {
        this.$message.error('请输入处理时间')
        return
      }
      if(!this.formData.id) {
        const res = await saveComplaintProgress({
          ...this.formData,
        })
        if(res.code === 0) {
          this.$message.success('添加成功')
          this.visibleAdd = false
          this.getList()
        }
      } else {
        const res = await updateComplaintProgress({
          ...this.formData,
        })
        if(res.code === 0) {
          this.$message.success('更新成功')
          this.visibleAdd = false
          this.getList()
        }
      }
     
   
    }
  }
}
</script>